/**
 * Parser Registry System for managing fermentation timeseries parsers
 * Implements Phase 2 of the SOW: Parser Interface Design
 */
export class FermentationParserRegistry {
    static instance;
    parsers = new Map();
    constructor() { }
    static getInstance() {
        if (!this.instance) {
            this.instance = new FermentationParserRegistry();
        }
        return this.instance;
    }
    /**
     * Register a parser for a specific equipment type
     */
    registerParser(parser) {
        const equipmentType = parser.equipmentType.toLowerCase();
        if (this.parsers.has(equipmentType)) {
            console.warn(`Parser for equipment type '${parser.equipmentType}' is already registered. Overwriting.`);
        }
        this.parsers.set(equipmentType, parser);
    }
    /**
     * Get parser for specific equipment type
     */
    getParser(equipmentType) {
        return this.parsers.get(equipmentType.toLowerCase()) || null;
    }
    /**
     * Get all registered equipment types
     */
    getAvailableParsers() {
        return Array.from(this.parsers.values()).map((parser) => ({
            equipmentType: parser.equipmentType,
            supportedFormats: parser.supportedFormats,
            argsSchema: parser.argsSchema,
        }));
    }
    /**
     * Check if equipment type is supported
     */
    isEquipmentTypeSupported(equipmentType) {
        return this.parsers.has(equipmentType.toLowerCase());
    }
    /**
     * Get supported file formats for an equipment type
     */
    getSupportedFormats(equipmentType) {
        const parser = this.getParser(equipmentType);
        return parser ? parser.supportedFormats : [];
    }
    /**
     * Clear all registered parsers (mainly for testing)
     */
    clear() {
        this.parsers.clear();
    }
}
// Export singleton instance
export const parserRegistry = FermentationParserRegistry.getInstance();
//# sourceMappingURL=parser-registry.js.map